import { FC, useMemo } from 'react';
import { useCommonFlavorCategories } from '@apiHooks/useCommonFlavorCategories';
import GroupedMultiSelect, {
    GroupedMultiSelectGroup,
} from '@components/new/GroupedMultiSelect/GroupedMultiSelect';

const SelectFlavorCategories: FC<{
    value: number[];
    setValue: (value: number[]) => void;
}> = ({ value, setValue }) => {
    const { data: categoriesDataRaw } = useCommonFlavorCategories();

    const groups: GroupedMultiSelectGroup[] = useMemo(() => {
        if (!categoriesDataRaw) return [];
        return categoriesDataRaw
            .filter((c): c is typeof c & { id: number } => c.id != null)
            .map((c) => ({
                id: c.id,
                name: c.name ?? '',
                options: (c.subCategories ?? [])
                    .filter((s): s is typeof s & { id: number } => s.id != null)
                    .map((s) => ({ id: s.id, name: s.name ?? '' })),
            }));
    }, [categoriesDataRaw]);

    return (
        <GroupedMultiSelect
            value={value}
            setValue={setValue}
            groups={groups}
            placeholder="Categories"
            unitLabel="Categories"
        />
    );
};

export default SelectFlavorCategories;
